import { render, staticRenderFns } from "./NotAdvanceClass.vue?vue&type=template&id=1942c042&scoped=true&"
import script from "./NotAdvanceClass.vue?vue&type=script&lang=js&"
export * from "./NotAdvanceClass.vue?vue&type=script&lang=js&"
import style0 from "./NotAdvanceClass.vue?vue&type=style&index=0&id=1942c042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942c042",
  null
  
)

export default component.exports